import api from "../../services/api";
import { types } from "../types/types";
import Constants from "../../utils/constants";
import { showLoaderAction, hideLoaderAction } from "./loaderAction";

const getActiveNetworkGasFees = () => async (dispatch) => {
    dispatch(showLoaderAction());
    const res = await api("get", Constants.endPoints.networkGasFees);
    if (res.success) {
        dispatch(hideLoaderAction());
        dispatch({
            type: types.NETWORK_GAS_FEES,
            payload: res.data || [],
        });
    } else {
        dispatch(hideLoaderAction());
        dispatch({
            type: types.NETWORK_GAS_FEES,
            payload: [],
        });
    }
};

export { getActiveNetworkGasFees };
